/**
 * 
 * File Upload
 * 
 */

 import React, { useState } from 'react'
 import PropTypes from 'prop-types'
 import Dropzone from "react-dropzone"
 import { Label, FormGroup } from 'reactstrap'
 import { formatBytes } from '../../helpers/tools'
 import api from '../../helpers/Api'
 
 function FileUpload(props) {
 
 
     const { label, name, required, onChange, value } = props
     const [uploading, setUploading] = useState(false)
 
     const handleAcceptedFiles = files => {
         setUploading(true)
         files.map(file =>
             Object.assign(file, {
                 preview: URL.createObjectURL(file),
                 formattedSize: formatBytes(file.size),
             })
         )
 
         const formData = new FormData()
         formData.append('file', files[0])
 
         api.post('/image_upload', formData).then(res => {
             if (res && res.data && res.data.data) {
                 onChange({ target: { value: res.data.data } })
             } else {
                 alert('Upload Failed!. Please try again')
             }
         }).catch(() => {
             alert('Unable to Upload file')
         }).finally(() => {
             setUploading(false)
         })
 
         props.onChange({ target: { value: JSON.stringify(files) } })
 
     }
 
     return (
         <React.Fragment>
             <FormGroup className='no-margin'>
                 <Label htmlFor="formrow-firstname-Input">{label} {required ? <span style={{ color: 'red' }}>*</span> : null}</Label>
                 {uploading ?
                     <div>Uploading file...</div> :
                     value ?
                         <div className="mb-3" style={{display: 'flex'}}>
                             <i style={{fontSize: "38px"}} className="text-muted bx bxs-file" onClick={() => window.open(value, '_blank')} />
                             <div style={{cursor: 'pointer', display: 'flex'}} onClick={()=> onChange({ target: { value: '' }})}>
                                 <i className="text-muted bx bxs-x-circle" style={{ fontSize: '20px', marginRight: '5px' }} /> <b>Remove</b>
                             </div>
                         </div>
                         : <Dropzone
                             onDrop={acceptedFiles =>
                                 handleAcceptedFiles(acceptedFiles)
                             }>
                             {({ getRootProps, getInputProps }) => (
                                 <div
                                     className='file-upload-btn'
                                     {...getRootProps()}>
                                     Choose File
                                     <input name={name} {...getInputProps()} />
                                 </div>
                             )}
                         </Dropzone>}
             </FormGroup>
         </React.Fragment>
     )
 }
 
 FileUpload.propTypes = {
     t: PropTypes.any,
     label: PropTypes.string,
     value: PropTypes.string,
     name: PropTypes.string,
     onChange: PropTypes.func,
     placeholder: PropTypes.string,
     isInvalid: PropTypes.any,
     required: PropTypes.bool,
     disabled: PropTypes.bool
 }
 
 export default FileUpload